<template>
  <div class="widget">
      <div v-if="loading === 'products'">
          <h1>Getting your products</h1>
          <Spinner></Spinner>
          <p>Please wait while we communicate with Envato</p>
      </div>
      <div v-if="loading === 'list'">
          <h1  v-if="typeof product === 'undefined' || product === null || product === ''"> Your Envato Market Purchases</h1>
          <h1  v-else>Your Envato Market Purchase</h1>
          <template v-if="products_list.length === 0">
              <img src="../assets/empty.svg" style="max-width: 24rem;margin: 1rem auto 0">
              <p>Looks like you don't have any Curly Themes products purchased from Envato Market</p>
          </template>
          <template v-else>
              <p v-if="typeof product === 'undefined' || product === null || product === ''">You have <strong>{{products_list.length}} <template v-if="products_list.length === 1">purchase</template><template v-else>purchases</template></strong> of Curly Themes products</p>
              <div v-for="prod in products_list" class="product">
                  <img :src="prod.icon">
                  <h3>{{prod.name}}</h3>
                  <p v-if="!hasSupport(prod)">Your last day of support is <strong>{{prod.until | moment("dddd, MMMM Do YYYY")}}</strong></p>
                  <p v-else>Your support period for this product has <strong>expired</strong>. Please extend your support.</p>
                  <template v-if="!hasSupport(prod)">
                      <router-link :to="{ name: 'Form', params: { code: prod.code, product: prod.id, until: prod.until, product_name: prod.name } }" class="btn-request">Request Support</router-link>
                  </template>
                  <template v-else>
                      <a :href="prod.url" class="btn-request">Extend Support</a>
                  </template>
              </div>
          </template>
          <p><router-link to="/">go back</router-link></p>
      </div>
      <div v-if="loading === 'error'">
          <h1>Oops, something went wrong!</h1>
          <img src="../assets/pisica.svg" style="max-width: 28rem;margin: 0 auto 3rem">
          <p>Please <router-link to="/">go back</router-link> and try again</p>
      </div>
  </div>
</template>

<script>
  /*eslint no-console: "error"*/
  import Spinner from '@/components/Spinner'
  import axios from 'axios'
  import tokensMixins from '@/mixins/tokens'
  import moment from 'moment'

export default {
    name: 'Products',
    props: {
        product: Object,
        code: String
    },
    data: function(){
      return {
          loading: 'products',
          products: []
      }
    },
    components: {
        Spinner
    },
    computed: {
      products_list: function(){
          var vm = this
          var list = []
          vm.products.forEach(function(i,k){
            list.push({
                name: i.item.name,
                license: i.license,
                until: i.supported_until,
                icon: i.item.previews.icon_preview.icon_url,
                url: i.item.url,
                id: i.item.id,
                code: i.code
            })
          })
          return list
      }
    },
    mounted: function(){
        var vm = this
        if( typeof this.product !== 'undefined' && this.product !== null && this.product !== '' ){
            const product = JSON.parse( JSON.stringify( vm.product ) )
            product.code = vm.code
            vm.products.push(product)
            vm.loading = 'list'
        } else{
            this.getProducts()
        }

    },
    methods: {
        hasSupport: function(p){
            return moment(p.until).isBefore( moment() )
        },
        getProducts: function(){
            var vm = this
            axios.get('https://my.curlythemes.com/.netlify/functions/getProducts',{
                params: {
                    token: vm.getAccessToken()
                }
            })
            .then(function (response) {
                if( response.status === 200 && typeof response.data.purchases !== 'undefined' ){
                    vm.products = response.data.purchases;
                    vm.loading = 'list'
                } else {
                    vm.loading = 'error'
                }
            })
            .catch(function (error) {
                vm.loading = 'error'
            })
        }
    },
    mixins: [ tokensMixins ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
